import React from "react";
import BahcelievlerSidebar from "../Sidebar/BahcelievlerSidebar";
import BahcelievlerOtherServices from "../ServiceAreas/BahcelievlerServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const BahcelievlerIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        BAHÇELİEVLER HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Bahçelievler bölgesinde halı ve koltuk yıkama hizmeti almak isteyen
            müşterilerimize özel, profesyonel ve titiz bir temizlik sunuyoruz.
            Modern makinelerimiz ve antibakteriyel temizlik ürünlerimizle,
            halılarınız ve koltuklarınız derinlemesine temizlenir, hijyenik bir
            ortam sağlanır.
          </p>

          <p>
            Geniş servis ağımızla Siyavuşpaşa, Şirinevler, Yenibosna, Zafer,
            Kocasinan gibi Bahçelievler’in tüm mahallelerinde hizmet
            veriyoruz. Halılar kapıdan teslim alınır, modern tesisimizde
            yıkanır ve paketlenmiş şekilde zamanında geri teslim edilir.
          </p>

          <p>
            <strong>Bahçelievler Halı-Koltuk Yıkama Avantajlarımız:</strong>
          </p>
          <ul className="list-disc list-inside">
            <li>Ücretsiz Alım ve Teslimat</li>
            <li>Buharlı ve Organik Temizlik</li>
            <li>Profesyonel Leke Çıkarma Garantisi</li>
            <li>Yerinde Koltuk Yıkama Seçeneği</li>
            <li>48 Saatte Teslim</li>
            <li>Her Halıya Uygun Yıkama Yöntemi</li>
          </ul>

          <p>
            Koltuk yıkama işlemlerimizde kumaş türüne göre özel kimyasal ve
            sıcak buhar sistemleri uygulanır. Yıkama sonrası koltuklarınız
            nemsiz bırakılır, küf oluşumu önlenir.
          </p>

          <p>
            Bahçelievler’in tüm mahallelerinde aynı gün içinde kapınızdan alım
            ve adrese teslim hizmetimizle güvenilir bir temizlik deneyimi
            yaşatıyoruz.
          </p>

          <p>
            Sipariş vermek veya detaylı bilgi almak için iletişim sayfamızdan
            bize ulaşabilirsiniz. Bahçelievler’de halı ve koltuk temizliğinde
            yıllardır güvenilen adres olmaya devam ediyoruz.
          </p>

          <BahcelievlerSidebar />
          <BahcelievlerOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default BahcelievlerIntro;
